import { Component, OnInit } from '@angular/core';
import { AppService } from '../../app.service';
import {Category, Product} from "../../app.models";

import {Observable, throwError} from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {catchError, map} from "rxjs/operators";
import {ApiUrl} from "../../shared/models/apiurl.models";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  private options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'

    })
  }
  public slides = null;

  public brands = null;
  public banners = [];
  public featuredProducts: Array<Product>;
  public onSaleProducts: Array<Product>;
  public topRatedProducts: Array<Product>;
  public newArrivalsProducts: Array<Product>;


  constructor(public appService:AppService, private http: HttpClient, private apiKey:ApiUrl) {
    this.loadData()
    this.loadBrandsData()
  }

  loadData(): void{
    this.getSliders().subscribe((res) => {
      this.slides = res.results.map((res) => {
        return {
          title: res.title,
          subtitle: res.subtitle,
          image: res.image,
          sortNumber: res.sortNumber,
          link: res.link
        }
      })
      this.slides.sort((a, b)=> a.sortNumber - b.sortNumber)
    })
  }

  loadBrandsData(): void{
    this.getBrands().subscribe((res) => {
      this.brands = res.results.map((res) => {
        return {
          name: res.name,
          image: res.image
        }
      })
    })
  }
  public mainCategories:Category[] =[];
  ngOnInit() {
    this.getBanners();
    this.getProducts("featured");
    this.getBrands();
    this.getCategories().subscribe(res => {
      this.mainCategories = res.object_list.filter(cate=>cate.hasSubCategory==true);
    })

  }

  public getCategories():Observable<any>{
    return this.http.get(this.apiKey.getCategories(), this.options)
        .pipe(map((res) => res ? res : null ),catchError(this.handleObserverError)
        );
  }

  public onLinkClick(e){
    this.getProducts(e.tab.textLabel.toLowerCase()); 
  }

  private handleObserverError(error: any): Observable<any>{
    return throwError(error.error || error)
  }

  public getSliders(): Observable<any>{
    return this.http.get(this.apiKey.getSliders(), this.options)
        .pipe(map((res) => res ? res : null ),catchError(this.handleObserverError)
        );
  }

  public getProducts(type){
    if(type == "featured" && !this.featuredProducts){
      this.appService.getProducts("featured",1,20).subscribe(data=>{
        this.featuredProducts = data.object_list;
      }) 
    }
    if(type == "on sale" && !this.onSaleProducts){
      this.appService.getProducts("on-sale",1,20).subscribe(data=>{
        this.onSaleProducts = data.object_list;
      })
    }
    if(type == "top rated" && !this.topRatedProducts){
      this.appService.getProducts("top-rated",1,20).subscribe(data=>{
        this.topRatedProducts = data.object_list;
      })
    }
    if(type == "new arrivals" && !this.newArrivalsProducts){
      this.appService.getProducts("new-arrivals",1,20).subscribe(data=>{
        this.newArrivalsProducts = data.object_list;
      })
    }
   
  }


  public getBanners(){
    this.appService.getBanners().subscribe((data:any)=>{
      this.banners = data.results;
    })
  }

  /*public getBrands(){
    this.brands = this.appService.getBrands();
  }
   */
  public getBrands(): Observable<any>{
    return this.http.get(this.apiKey.getBrands(), this.options)
        .pipe(map((res) => res ? res : null ),catchError(this.handleObserverError)
        );
  }


}
